/**
 * [众包骑士]
 * @author: Fu Xiaochun
 * @date: 2021-09-01 
 */

import http from '@/assets/api/http';

// 获取众包骑士列表
export async function getCrowdsourcingRiderList(params){
    return http('/?cmd=com.xqxc.api.pig.microep.account.MicroAcMepRiderInfoService.list',params,'POST');
}

// 修改众包骑士状态：禁用，启用
export async function updateRiderStatus(params){
    return http('/?cmd=com.xqxc.api.pig.microep.account.MicroAcMepRiderInfoService.modifyStatus',params,'POST');
}

// 众包骑士服务区域
export async function getServiceArea(params){
    return http('/?cmd=com.xqxc.api.pig.microep.account.MicroAcMepRiderInfoService.cityList',params,'POST');
}

// 新建骑士
export async function addRider(params){
    return http('/?cmd=com.xqxc.api.pig.microep.account.MicroAcMepRiderInfoService.add',params,'POST');
}

// 骑士详情
export async function riderDetail(params){
    return http('/?cmd=com.xqxc.api.pig.microep.account.MicroAcMepRiderInfoService.detail',params,'POST');
}

// 骑士收支明细
export async function riderPayment(params){
    return http('/?cmd=com.xqxc.api.pig.microep.settle.MicroAccountService.detail',params,'POST');
}

// 骑士总收入
export async function riderTotalIncome(params){
    return http('/?cmd=com.xqxc.api.pig.microep.settle.MicroAccountService.get',params,'POST');
}

// 骑士修改小运力日志
export async function riderChangeLogs(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.RiderAccountMisService.getRiderTransportLog',params,'POST');
}

// 骑士修改小运力日志
export async function smallTransportList(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.smallTransportList',params,'POST');
}

// 骑士修改小运力
export async function riderChangeSmallTransport(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.RiderAccountMisService.updateRiderTransport',params,'POST');
}